import React from 'react';
import { useContactUsLink } from '#/hooks/useContactUsLink';
import { ContactUsLink as UIContactUsLink } from '@jucy-ui/components/ContactUs';

type ContactUsLinkProps = { children?: React.ReactNode; className?: string; reservationRef?: string; target?: string };

export const ContactUsLink: React.FC<ContactUsLinkProps> = ({ children, className, reservationRef, target }) => {
    const href = useContactUsLink(reservationRef);

    return (
        <UIContactUsLink className={className} href={href} target={target}>
            {children}
        </UIContactUsLink>
    );
};
